export default "__VITE_ASSET__HhRMe3hv__"